import { Map } from 'immutable'
import {
  SET_ACTIVE_ARROW,
  SET_IS_TOUR_ACTIVE,
} from './actions'

export const initialState = Map({
  isActive: false,
})

export default (state = initialState, action) => {
  const { payload, type } = action
  switch (type) {
    case SET_ACTIVE_ARROW:
      return state.set('activeArrow', payload)
    case SET_IS_TOUR_ACTIVE:
      return state.set('isActive', payload)
    default:
      return state
  }
}
